/* Saturday Archives: small, dependency-free storefront script */
(() => {
  const T = window.theme || { routes: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    document.documentElement.classList.toggle('menu-open', !open);
  });

  /* ---------- Cart drawer ---------- */
  const getDrawer = () => $('[data-cart-drawer]');

  const openDrawer = () => {
    const d = getDrawer();
    if (d && !d.open) d.showModal();
  };
  const closeDrawer = () => {
    const d = getDrawer();
    if (d && d.open) d.close();
  };

  async function updateCount() {
    try {
      const res = await fetch(T.routes.cart_js, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    } catch (_) { /* non-critical */ }
  }

  async function refreshDrawer() {
    const res = await fetch(`${T.routes.cart}?section_id=cart-drawer`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = $('[data-drawer-content]', doc);
    const current = $('[data-drawer-content]');
    if (next && current) current.innerHTML = next.innerHTML;
    await updateCount();
  }

  async function changeLine(line, quantity) {
    await fetch(`${T.routes.cart_change}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });
    await refreshDrawer();
  }

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && getDrawer() && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      try { await refreshDrawer(); } catch (_) { /* show stale content */ }
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    const qty = e.target.closest('[data-qty-change]');
    if (qty) {
      qty.disabled = true;
      try { await changeLine(qty.dataset.line, qty.dataset.qty); }
      catch (_) { qty.disabled = false; }
      return;
    }

    if (e.target.matches('dialog')) e.target.close();           // click on backdrop
    if (e.target.closest('[data-dialog-close]')) e.target.closest('dialog').close();
    if (e.target.closest('[data-size-guide-open]')) {
      const root = e.target.closest('[data-product-root]') || document;
      const dlg = $('[data-size-guide]', root);
      if (dlg) dlg.showModal();
    }
  });

  /* ---------- Quick add (product cards) ---------- */
  let autoCloseTimer;
  const cancelAutoClose = () => clearTimeout(autoCloseTimer);
  const slideCloseDrawer = () => {
    const d = getDrawer();
    if (!d || !d.open) return;
    d.classList.add('is-closing');
    setTimeout(() => { d.classList.remove('is-closing'); if (d.open) d.close(); }, 240);
  };
  const scheduleAutoClose = () => {
    cancelAutoClose();
    autoCloseTimer = setTimeout(slideCloseDrawer, 3200);
  };
  // Keep the drawer open if the shopper interacts with it.
  document.addEventListener('pointerover', (e) => {
    if (e.target.closest('[data-cart-drawer] .drawer__content')) cancelAutoClose();
  });
  document.addEventListener('keydown', cancelAutoClose);
  document.addEventListener('close', cancelAutoClose, true);

  async function addVariant(id) {
    const res = await fetch(`${T.routes.cart_add}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
    await refreshDrawer();
  }

  // Desktop: hover sizes on the card.
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add-variant]');
    if (!btn || btn.disabled || btn.closest('[data-qa-sheet]')) return;
    e.preventDefault();
    const wrap = btn.closest('[data-quick-add]');
    if (!wrap || wrap.classList.contains('is-busy')) return;
    wrap.classList.add('is-busy');
    try {
      await addVariant(btn.dataset.quickAddVariant);
      openDrawer();
      scheduleAutoClose();
    } catch (err) {
      const label = $('.qa__label', wrap);
      if (label) label.textContent = (err && err.message) || T.strings.error || 'try again';
      wrap.classList.add('is-error');
      setTimeout(() => {
        wrap.classList.remove('is-error');
        if (label) label.textContent = 'quick add';
      }, 2200);
    } finally {
      wrap.classList.remove('is-busy');
    }
  });

  // Mobile: "+" opens a bottom sheet built from the tapped card.
  const sheet = $('[data-qa-sheet]');
  if (sheet) {
    const sizesEl = $('[data-sheet-sizes]', sheet);
    const addBtn = $('[data-sheet-add]', sheet);
    let chosen = null;

    const closeSheet = (cb) => {
      sheet.classList.add('is-closing');
      setTimeout(() => {
        sheet.classList.remove('is-closing');
        if (sheet.open) sheet.close();
        if (cb) cb();
      }, 220);
    };
    const resetBtn = () => { addBtn.textContent = 'add to bag'; addBtn.classList.remove('is-error'); addBtn.disabled = false; };

    document.addEventListener('click', (e) => {
      const plus = e.target.closest('[data-qa-sheet-open]');
      if (plus) {
        e.preventDefault();
        const card = plus.closest('.card');
        $('[data-sheet-title]', sheet).textContent = $('.card__title', card).textContent;
        $('[data-sheet-price]', sheet).textContent = $('.card__price', card).textContent.trim();
        $('[data-sheet-details]', sheet).href = $('.card__info', card).getAttribute('href');
        sizesEl.innerHTML = '';
        chosen = null;
        $$('[data-quick-add-variant]', card).forEach((src) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.textContent = src.textContent;
          b.dataset.variant = src.dataset.quickAddVariant;
          b.disabled = src.disabled;
          b.setAttribute('aria-pressed', 'false');
          sizesEl.appendChild(b);
        });
        resetBtn();
        sheet.showModal();
        return;
      }
      const size = e.target.closest('[data-sheet-sizes] button');
      if (size && !size.disabled) {
        $$('button', sizesEl).forEach((b) => b.setAttribute('aria-pressed', String(b === size)));
        chosen = size.dataset.variant;
        resetBtn();
      }
    });

    addBtn.addEventListener('click', async () => {
      if (!chosen) {
        addBtn.textContent = T.strings.select_size;
        addBtn.classList.add('is-error');
        return;
      }
      addBtn.disabled = true;
      addBtn.textContent = T.strings.adding;
      try {
        await addVariant(chosen);
        closeSheet(openDrawer);
      } catch (err) {
        addBtn.disabled = false;
        addBtn.classList.add('is-error');
        addBtn.textContent = (err && err.message) || T.strings.error;
      }
    });

    // Swipe down on the handle / top of the sheet to dismiss.
    let startY = null;
    sheet.addEventListener('touchstart', (e) => { if (sheet.scrollTop <= 0) startY = e.touches[0].clientY; }, { passive: true });
    sheet.addEventListener('touchend', (e) => {
      if (startY !== null && e.changedTouches[0].clientY - startY > 70) closeSheet();
      startY = null;
    });
  }

  /* ---------- Product page ---------- */
  const money = (cents) => {
    const whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: T.currency || 'USD',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (_) { return (cents / 100).toFixed(whole ? 0 : 2); }
  };

  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    const jsonEl = $('[data-product-json]', root);
    const form = $('[data-product-form]', root);
    if (!jsonEl || !form) return;

    const product = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const button = $('[data-add-to-bag]', form);
    const errorEl = $('[data-form-error]', form);
    const gallery = $('[data-gallery]', root);
    const counter = $('[data-gallery-counter]', root);
    const priceEl = $('[data-price-current]', root);
    const compareEl = $('[data-price-compare]', root);
    const fields = $$('[data-option]', root);
    const label = button ? button.dataset.label || T.strings.add_to_bag : '';

    const selected = () => fields.map((f) => {
      if (f.matches('select')) return f.value;
      const checked = $('input:checked', f);
      return checked ? checked.value : '';
    });

    const resolve = () => {
      if (!fields.length) return product.variants[0];
      const sel = selected();
      if (sel.some((v) => !v)) return null;
      return product.variants.find((v) => v.options.every((o, i) => o === sel[i])) || null;
    };

    const setButton = (variant) => {
      if (!button) return;
      if (variant && !variant.available) {
        button.disabled = true;
        button.textContent = T.strings.sold_out;
      } else {
        button.disabled = false;
        button.textContent = label;
      }
    };

    const scrollToMedia = (variant) => {
      const id = variant && variant.featured_media && variant.featured_media.id;
      if (!id || !gallery) return;
      const target = $(`[data-media-id="${id}"]`, gallery);
      if (target && gallery.scrollWidth > gallery.clientWidth) {
        gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    };

    const update = () => {
      const variant = resolve();
      idInput.value = variant ? variant.id : '';
      if (errorEl) errorEl.textContent = '';
      if (variant) {
        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl) {
          const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
          compareEl.hidden = !sale;
          if (sale) compareEl.textContent = money(variant.compare_at_price);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        scrollToMedia(variant);
      }
      setButton(variant);
    };

    fields.forEach((f) => f.addEventListener('change', update));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!idInput.value) {
        if (errorEl) errorEl.textContent = T.strings.select_size;
        const first = fields.find((f) => (f.matches('select') ? !f.value : false));
        if (first) first.focus();
        return;
      }
      button.disabled = true;
      button.textContent = T.strings.adding;
      try {
        const res = await fetch(`${T.routes.cart_add}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        await refreshDrawer();
        openDrawer();
      } catch (err) {
        if (errorEl) errorEl.textContent = err.message || T.strings.error;
      } finally {
        setButton(resolve());
      }
    });

    if (gallery && counter) {
      const total = $$('[data-media-id]', gallery).length;
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        counter.textContent = `${Math.min(i + 1, total)} / ${total}`;
      }, { passive: true });
    }
  }

  const initAll = (scope = document) => $$('[data-product-root]', scope).forEach(initProduct);
  initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
